import {
  AsendingSortingIcon,
  DefaultSortingIcon,
  DeleteIcon,
  DesendingSortingIcon,
} from "../../assets/icons/iconsProvider";
import {
  EMPTY_STRING,
  globalConstants,
  inventoryConstants,
  toastMessages,
  toastType,
  tradeInDiscountConstant,
} from "../../constants";
import { PRODUCT_TYPES_ENUMS } from "../../system/globalEnums";
import {
  customToast,
  filterApplyToSearchOptions,
  getProductSubCategory,
} from "../utility";

//------- This function handles the setting of the 'Set By' filter in the trade-in margin utility.
export const handleSetByChange = (
  option,
  customTypes,
  setSetByFilter,
  setSelectedTags,
  customCategories,
  filterProductType,
  setItemMarginUnit,
  selectedCategories,
  setSearchCategories,
  customSubCategories,
  setSelectedCondition,
  setSelectedCategories,
  filterProductCategory,
  setModalCheckBoxStatus
) => {
  setSelectedCategories([]);
  setSetByFilter(option);
  setSearchCategories(
    filterApplyToSearchOptions(
      option,
      customTypes.filter(
        (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
      ),
      customCategories,
      customSubCategories,
      filterProductType,
      filterProductCategory,
      selectedCategories
    )
  );
  setItemMarginUnit(false);
  setSelectedCondition(inventoryConstants.VIDEO_GAME_CONDITION[0]);
  setSelectedTags([]);
  setModalCheckBoxStatus(false);
};

//------- This function handle product click in opton list of trade-in margin utility.
export const handleMenuProductClick = (
  value,
  selectedCategories,
  setSelectedCategories
) => {
  if (selectedCategories?.length >= tradeInDiscountConstant.MAXIMUM_PRODUCTS) {
    customToast(
      `Maximum ${tradeInDiscountConstant.MAXIMUM_PRODUCTS} products is allowed at a time.`,
      toastType.ERROR
    );
    return;
  }

  const isProductAlreadyExist = selectedCategories.find(
    (item) => item.product_id === value.product_id
  );
  if (isProductAlreadyExist) {
    customToast(toastMessages.PRODUCT_ALREADY_ADDED, toastType.ERROR);
    return;
  }

  setSelectedCategories([
    ...selectedCategories,
    {
      product_id: value.product_id,
      product_name: value.product_name,
      productType: value.productType,
      category_name: value.category_name,
      cardRarity: EMPTY_STRING,
      subcategory: getProductSubCategory(value.genre),
    },
  ]);
};

//-------
export const getFormatedColumns = (categoriesColumn) => {
  const formattedColumns = categoriesColumn.map((column) => {
    if (column.sortable) {
      return {
        ...column,
        name: (
          <div className=" d-flex w-100">
            {column.name}
            <div className="ml-2 d-flex justify-content-center align-items-center">
              {column.sortDirection === null && (
                <DefaultSortingIcon className="ms-1 cursor-pointer" />
              )}
              {column.sortDirection === globalConstants.SORT.ASC && (
                <AsendingSortingIcon className="ms-1 cursor-pointer" />
              )}
              {column.sortDirection === globalConstants.SORT.DESC && (
                <DesendingSortingIcon className="ms-1 cursor-pointer" />
              )}
            </div>
          </div>
        ),
      };
    } else {
      return column;
    }
  });

  return formattedColumns;
};

//-------
export const getProductMargnColumns = (
  searchCategories,
  setSearchCategories,
  selectedCategories,
  setSelectedCategories
) => {
  return [
    {
      id: "name",
      name: "Name",
      selector: (row) => row.product_name,
      cell: (row) => (
        <span className="users-cell-max-size">{row.product_name}</span>
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "type",
      name: "Type",
      selector: (row) => row.productType,
      cell: (row) => (
        <span className="users-cell-max-size">{row.productType}</span>
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "category_name",
      name: "Category",
      selector: (row) => row.category_name,
      cell: (row) => (
        <span className="users-cell-max-size">{row.category_name}</span>
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "action",
      name: "",
      cell: (row) => {
        return (
          <>
            {
              <button
                type="button"
                onClick={() => {
                  removeSelectedCategory(
                    row?.product_id,
                    searchCategories,
                    setSearchCategories,
                    selectedCategories,
                    setSelectedCategories,
                    true
                  );
                }}
                id={`tool${row.id}`}
                className="action-Button-Wrapper"
              >
                <DeleteIcon className="cursor-pointer" />
              </button>
            }
          </>
        );
      },
      sortable: false,
      width: "5%",
    },
  ];
};

//-------
export const getTypeCategoryColumns = (
  searchCategories,
  setSearchCategories,
  selectedCategories,
  setSelectedCategories
) => {
  return [
    {
      id: "categoryName",
      name: "Category Name",
      selector: (row) => row.name,
      cell: (row) => <span className="users-cell-max-size">{row.name}</span>,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "action",
      name: "",
      cell: (row) => {
        return (
          <>
            {
              <button
                type="button"
                onClick={() => {
                  removeSelectedCategory(
                    row?.name,
                    searchCategories,
                    setSearchCategories,
                    selectedCategories,
                    setSelectedCategories
                  );
                }}
                id={`tool${row.id}`}
                className="action-Button-Wrapper"
              >
                <DeleteIcon className="cursor-pointer" />
              </button>
            }
          </>
        );
      },
      sortable: false,
      width: "5%",
    },
  ];
};

export const removeSelectedCategory = (
  categoryToRemove,
  searchCategories,
  setSearchCategories,
  selectedCategories,
  setSelectedCategories,
  isProductMargin = false
) => {
  if (isProductMargin) {
    setSelectedCategories(
      selectedCategories.filter(
        (product) => product.product_id !== categoryToRemove
      )
    );
  } else {
    setSelectedCategories(
      selectedCategories.filter(
        (category) => category.name !== categoryToRemove
      )
    );

    const fullCategoryObject = selectedCategories.find(
      (category) => category.name === categoryToRemove
    );

    if (fullCategoryObject) {
      setSearchCategories(
        [...searchCategories, fullCategoryObject].sort((a, b) =>
          a.name.localeCompare(b.name)
        )
      );
    }
  }
};
